import { VenueBreadcrumbReactionSummaryDto } from '@ivy-monorepo/shared'

interface BreadcrumbReactionsSummaryProps {
  reactions?: VenueBreadcrumbReactionSummaryDto[]
}

const BreadcrumbReactionsSummary = ({ reactions }: BreadcrumbReactionsSummaryProps) => {
  if (!reactions?.length) {
    return <span className="breadcrumb-reactions-empty">No reactions</span>
  }

  return (
    <div className="breadcrumb-reactions">
      {reactions.map(reaction => (
        <span key={reaction.emoji} className="breadcrumb-reaction-chip" title={`${reaction.count} reaction(s)`}>
          <span className="breadcrumb-reaction-emoji">{reaction.emoji}</span>
          {reaction.count > 1 && <span className="breadcrumb-reaction-count">{reaction.count}</span>}
        </span>
      ))}
    </div>
  )
}

export default BreadcrumbReactionsSummary
